import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { NAV_ITEMS } from "src/environments/environment";

@Component({
  selector: 'app-header',
  standalone: false,

  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
  options = NAV_ITEMS.slice(3);
  displayNavItems = NAV_ITEMS.slice(0, 3);
  isDashboard;
  constructor(private router: Router) {}

  ngOnInit(): void {}

  redirect(route) {
    this.router.navigate(["/" + route]);
  }
}
